import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { Column } from '@/components/content/HdmSkucomparer/parts/Column';
import { columnTitleStyles } from '@/components/content/HdmSkucomparer/styles';

export const ColumnTitle = ({ title, ...props }: { title: string }) => {
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

	return (
		<Column sx={columnTitleStyles.container} isVisible={isDesktop} {...props}>
			<Typography variant="body1" component="h4" sx={columnTitleStyles.text}>
				{title}
			</Typography>
		</Column>
	);
};
